import { render } from "./MultiSelectImageText.vue?vue&type=template&id=146f6918&scoped=true"
import script from "./MultiSelectImageText.vue?vue&type=script&lang=ts"
export * from "./MultiSelectImageText.vue?vue&type=script&lang=ts"

import "./MultiSelectImageText.vue?vue&type=style&index=0&id=146f6918&lang=less&scoped=true"
import "./MultiSelectImageText.vue?vue&type=style&index=1&id=146f6918&lang=less"
script.render = render
script.__scopeId = "data-v-146f6918"

export default script